/* tslint:disable: no-unused-variable */
import { PmdAccordionModule } from './accordion/accordion.module';
import { PmdAlertModule } from './alert/alert.module';
import { PmdDatepickerInlineConfig } from './datepicker/pmd-datepicker-inline.config';
import { PmdDaterangepickerConfig } from './datepicker/pmd-daterangepicker.config';
import { PmdButtonToggleModule } from './button-toggle/buttons.module';
import { PmdButtonModule } from './button/button.module';
import { PmdFormGroupModule } from './input/input.module';
import { PmdRippleEffectModule } from './ripple/ripple.module';
import { CarouselModule } from './carousel/carousel.module';
import { PmdCollapseModule } from './collapse/collapse.module';
import { DatepickerModule } from './datepicker/datepicker.module';
import { PmdDropdownModule } from './dropdown/dropdown.module';
import { PmdModalModule } from './modal/modal.module';
import { PaginationModule } from './pagination/pagination.module';
import { PmdPopoverModule } from './popover/popover.module';
import { PmdProgressbarModule } from './progressbar/progressbar.module';
import { RatingModule } from './rating/rating.module';
import { SortableModule } from './sortable/index';
import { PmdTabsModule } from './tabs/tabs.module';
import { TimepickerModule } from './timepicker/timepicker.module';
import { PmdTooltipModule } from './tooltip/tooltip.module';
import { TypeaheadModule } from './typeahead/typeahead.module';
import { PmdSidebarModule } from './sidebar/sidebar.module';
import { PmdNavbarModule } from './navbars/navbar.module';

import { PmdCardModule } from './card/card-module';
export { listLocales } from './chronos/locale/locales';
export { setTheme } from './utils/theme-provider';

export {
  PmdAccordion,
  PmdAccordionItemHeader,
  PmdAccordionConfig,
  PmdAccordionModule,
  PmdAccordionItem
} from './accordion/index';


export { 
  PmdAlert, 
  PmdAlertConfig, 
  PmdAlertModule 
} from './alert/index';

export {
  PmdButtonCheckbox,
  PmdButtonRadio,
  PmdButtonToggleModule
} from './button-toggle/index';

export {
  PmdButton,
  PmdButtonModule
} from './button/index';

export {
  PmdFormGroup,
  PmdInput,
  PmdFormGroupModule,
} from './input/index';
export {
  CarouselComponent,
  CarouselConfig,
  CarouselModule,
  SlideComponent
} from './carousel/index';

export { 
  PmdCollapse, 
  PmdCollapseModule,
  PmdCollapseAccordion 
} from './collapse/index';

export {
  BsDatepickerConfig,
  BsDatepickerDirective,
  PmdDatepickerInlineConfig,
  BsDatepickerModule,
  PmdDaterangepickerConfig,
  BsDaterangepickerDirective,
  BsLocaleService,
  DateFormatter,
  DatePickerComponent,
  DatepickerConfig,
  DatepickerModule,
  DayPickerComponent,
  MonthPickerComponent,
  YearPickerComponent,
  // DatepickerdateClass,
  DatepickerDateCustomClasses
} from './datepicker/index';

export {
  PmdModal,
  ModalTrap,
  PmdModalOptions,
  PmdModalBackdropOptions,
  PmdModalBackdrop,
  PmdModalModule,
  PmdModalRef,
  PmdModalService
} from './modal/index';

export {
  PmdDropdownModule,
  PmdDropdownConfig,
  PmdDropdownState,
  PmdDropdownContainer,
  PmdDropdown,
  PmdDropdownMenu,
  PmdDropdownToggle
} from './dropdown/index';

export {
  PagerComponent,
  PaginationComponent,
  PaginationConfig,
  PaginationModule,
  PageChangedEvent
} from './pagination/index';

export {
  PmdBar,
  PmdProgressbar,
  PmdProgressbarConfig,
  PmdProgressbarModule
} from './progressbar/index';

export { 
  RatingComponent, 
  RatingModule 
} from './rating/index';

export { 
  PmdSidebar,
  PmdSidebarModule 
} from './sidebar/index';
export { 
  pmdMediaList,
  PmdCard,
  PmdCardAvatar,
  PmdCardBody,
  PmdCardFooter,
  PmdCardHeader,
  PmdCardHeaderMedia,
  PmdCardImage,
  PmdCardSubtitle,
  PmdCardText,
  PmdCardTitle,
  PmdCardModule 
} from './card/index';
export { 
  PmdNavbar,
  PmdNavbarModule 
} from './navbars/index';
export {
  DraggableItem,
  DraggableItemService,
  SortableItem,
  SortableComponent,
  SortableModule
} from './sortable/index';

export {
  PmdTransclude,
  PmdTab,
  PmdTabLabel,
  PmdTabGroup,
  PmdTabGroupConfig,
  PmdTabsModule
} from './tabs/index';

export {
  TimepickerComponent,
  TimepickerConfig,
  TimepickerModule
} from './timepicker/index';

export {
  PmdTooltipConfig,
  PmdTooltipContainer,
  PmdTooltip,
  PmdTooltipModule
} from './tooltip/index';

export {
  TypeaheadOptions,
  TypeaheadContainerComponent,
  TypeaheadDirective,
  TypeaheadMatch,
  TypeaheadModule
} from './typeahead/index';

export {
  PmdPopoverConfig,
  PmdPopoverContainer,
  PmdPopover,
  PmdPopoverModule
} from './popover/index';

export {
  OnChange,
  document,
  window,
  parseTriggers,
  LinkedList,
  isBs3,
  Trigger,
  warnOnce,
  Utils,
  listenToTriggersV2,
  registerOutsideClick
} from './utils/index';

export {
  ComponentLoader,
  ComponentLoaderFactory,
  ContentRef,
  pmdComponentRef
} from './component-loader/index';

export {
  Positioning,
  PositioningOptions,
  PositioningService,
  positionElements
} from './positioning/index';

export {
  Action,
  MiniState,
  MiniStore
} from './mini-ngrx/index';

export {
  defineLocale,
  getSetGlobalLocale,
  LocaleData,
  parseDate,
  formatDate,
  getDay,
  isFirstDayOfWeek,
  isSameYear,
  isSameDay,
  isSameMonth,
  getFullYear,
  getFirstDayOfMonth,
  getMonth,
  getLocale,
  updateLocale,
  isAfter,
  isBefore,
  isArray,
  isDateValid,
  isDate,
  shiftDate,
  setFullDate,
  endOf,
  startOf,
  TimeUnit
} from './chronos/index';

export * from './locale';
